import { createFileRoute } from "@tanstack/react-router";
import { AdminShell } from "@/components/admin/admin-shell";
import { CommCenterInner } from "@/components/comm/comm-center";

export const Route = createFileRoute("/admin/comms")({
  component: () => (
    <AdminShell title="Communication Centre" subtitle="Messages, voice notes, video calls and announcements">
      <CommCenterInner role="admin" />
    </AdminShell>
  ),
});
